import React from "react";
import { translate } from "react-i18next";
import { Container, ResponseDetail, EditButton } from "./styles";
import { Label } from "../../../styles/defaults";
import { types } from "./voteTypes";

const Details = ({
  t,
  questions,
  onEdit,
  lang,
  isAgent = false,
  isChat = false
}) => {
  function renderLabel(type, response) {
    switch (type) {
      case 1:
        const satisfaction = types.satisfaction.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(satisfaction);

      case 2:
        const smiles = types.smiles.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(smiles);

      case 3:
        const nps = types.NPS.find(el => {
          if (response === el.response) return el.Label;
        });
        return returnComponent(nps);
      case 4:
        const yesNo = types.yesNo.find(el => {
          if (response === el.response) return el.Label;
        });

        return returnComponent(yesNo);

      default:
        return;
    }
  }

  function returnComponent({ Label, color, description }) {
    return color ? <Label bgColor={color}>{t(description)}</Label> : Label;
  }

  function handleRenderDescription(languages) {
    const { description } = languages.find(
      ({ language }) => language.substring(0, 2) === lang
    );

    return description;
  }

  return (
    <Container>
      {questions.map((el, index) => (
        <ResponseDetail key={index}>
          <p>{handleRenderDescription(el.languages)}</p>
          <Label>{renderLabel(el.type, el.response)}</Label>
          {el.commentaryEnabled && <h6>{t("comment")}</h6>}
          <p>{el.comment}</p>
        </ResponseDetail>
      ))}
      {!isAgent && <EditButton onClick={onEdit}>{t("edit")}</EditButton>}
    </Container>
  );
};

export default translate("translations")(Details);
